import React from "react";

import Presentation from "./presentation";

const component =  ( {
	setSelectedImage,
	index,
	image,
	bottomLeftFlag,
	bottomRightFlag,
	topLeftFlag,
	topRightFlag,
	handleImageModalOpen
} ) => {

	const setImageForModal = () => {
		setSelectedImage ( { index, image } );
	};

	return (
		<Presentation
			bottomLeftFlag       = { bottomLeftFlag }
			bottomRightFlag      = { bottomRightFlag }
			handleImageModalOpen = { handleImageModalOpen }
			image                = { image }
			setImageForModal     = { setImageForModal }
			topLeftFlag          = { topLeftFlag }
			topRightFlag         = { topRightFlag }
		/>

	);
};

export default component;